import { Component, OnInit } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { DetailsService } from '../../services/details.service';
import { IDetailType, IInventoryMasterDetail, IFoodType, IFoodSize, IFeedingLineItemDetail,
         IFecalAppearance, IShedType, IHealthIncidentType, IFecalLineItemDetail, IShedLineItemDetail,
         IHealthLineItemDetail, IGrowthLineItemDetail, IFeedingOutcome, IFeedingType, IDetailLineItem, IViewDetailLineItem } from '../../interfaces/';
import { DetailType, FeedingLineItemDetail, FecalLineItemDetail, ShedLineItemDetail, HealthLineItemDetail,
         GrowthLineItemDetail, DetailLineItem, ViewDetailLineItem } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'print-id-cards',
  templateUrl: './print-id-cards.component.html',
  styleUrls: ['./print-id-cards.component.css']
})
export class PrintIdCardsComponent implements OnInit {

	public inventory: IInventoryMasterDetail[] = [];	
  public masterRecord: IInventoryMasterDetail;

  selectedMasterId: number = 0;
	selectedDetailType: any;
  message = "";
  groupId: number = 0;

  saveSuccess: boolean;
  isAuthenticated: boolean = false;
  selections: any[] = [];
  SelectedOption: string;
  inventorySelections: IInventoryMasterDetail[] = [];

  constructor(private detailsService: DetailsService, private router: Router, 
              private route: ActivatedRoute, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    
    if(this.route.snapshot.paramMap.get('grp')){
      this.groupId = parseInt(this.route.snapshot.paramMap.get('grp'));
    }
    else{
      if(sessionStorage.getItem("token")){
          let obj = JSON.parse(sessionStorage.getItem("token"));
          if(obj && obj.Token != ""){
            this.isAuthenticated = true;
          }
      }
      else {
        this.router.navigate(['/login']);
      }
    }

    if(this.route.snapshot.paramMap.get('id')){
      this.selectedMasterId = parseInt(this.route.snapshot.paramMap.get('id'));
    }
    else {
      this.selectedMasterId = 0;  
    }

    if(sessionStorage.getItem("groupId")){
      let group = JSON.parse(sessionStorage.getItem("groupId"));
      if(group && group.GroupId != 0){
          this.groupId = group.GroupId;
      }
    }
    this.loadInventoryList(); 

  }

  eventlog()
  {
    //console.log(this.selectedDetailType);
  }

  
  loadInventoryList(){
    this.inventory = [];
    this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
      resp => {
      this.inventory = resp;
    });
  }

  modifySelections(recordId)
  {
    if(this.selections.length ==0)
    {
      this.selections.push(recordId);
    }
    else{
      let exists = this.selections.find(s => { return s == recordId});
      if(exists){
        let index = this.selections.indexOf(exists);
        if (index !== -1) {
            this.selections.splice(index, 1);
        }
      }
      else{
         this.selections.push(recordId);   
      }
    }
  }

  generateCards(size: string)
  {
    this.SelectedOption = size;

    this.inventorySelections = [];
    this.selections.forEach(s => {
      let item = this.inventory.find(i => {return i.Id == s});
      if(item){
        this.inventorySelections.push(item);
      }
    })
    
  }

  checked(Id)
  {
    let isChecked = this.selections.find(s => {return s == Id});
    if(isChecked){
      return true;
    }
    else
    {
      return false;
    }
  }

  selectAll()
  {
    this.selections = [];
    this.inventory.forEach(i =>{
        this.selections.push(i.Id)
    });
    console.log(this.selections);
  }

  deselectAll()
  {
    this.selections = [];
  }

  printQR(){
    const printContent = document.getElementById('generatedQRDetails');
    const printWindow = window.open('','','left=0,top=0,width=1200,height=900,toolbar=0,scrollbars=0,status=0')
    
    printWindow.document.write(printContent.innerHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();    
  }
}



// WEBPACK FOOTER //
// ./src/app/inventory-manager/print-id-cards/print-id-cards.component.ts